import { useQuery } from '@apollo/client';
import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import { Status as SaveStatus } from '../post/PostSaveTracker';
import PostLastEdited from '../post/topbar/PostLastEdited';
import styles from './PostStatus.module.scss';
import { gql } from '../graphql/generated/gql';

const POST_QUERY = gql(`
  query PostStatusPost($id: ID!) {
    post(id: $id) {
      id
      ...PostLastEdited_post
      lastHistory {
        ...PostLastEdited_lastHistory
      }
    }
  }
`);

const getStatusText = (status: string) => {
  switch (status) {
    case SaveStatus.SAVED:
      return 'Saved';
    case SaveStatus.SAVING:
      return 'Saving...';
    default:
      return '';
  }
};

const PostStatus = () => {
  const isEditable = useAppSelector((state) => state.editor.editable);
  const isLocked = useAppSelector(
    (state) => state.session.organization.isLocked,
  );
  const postId = useAppSelector((state) => state.editor.postId);
  const readOnly = useAppSelector((state) => state.editor.readOnly);
  const saveStatus = useAppSelector((state) => state.editor.saveStatus);

  const { data } = useQuery(POST_QUERY, {
    // @ts-expect-error
    variables: { id: postId },
    skip: !postId,
  });

  const post = data?.post;
  if (!post) {
    return null;
  }

  return (
    <div className={styles.container}>
      {readOnly ? (
        <PostLastEdited
          post={post}
          lastHistory={post.lastHistory || undefined}
          showTooltip={isEditable && !isLocked}
        />
      ) : (
        getStatusText(saveStatus)
      )}
    </div>
  );
};

export default PostStatus;
